exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".material-icons[data-v-b4230b7e]{font-size:34px}\n", ""]);

// exports
